export default "__VITE_ASSET__Q31GXIAB__"